import React from 'react';
import { BrainIcon, ZapIcon, TargetIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 relative overflow-hidden" data-id="element-105">
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-brand-900/10 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-106"></div>

      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <div className="inline-flex items-center justify-center p-4 bg-brand-900/30 rounded-full mb-6 border border-brand-800/50" data-id="element-109">
            <BrainIcon className="h-10 w-10 text-brand-400" data-id="element-110" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-111">
            El Protocolo de Clústeres
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" data-id="element-112">
            A diferencia de los libros teóricos de psicología, este sistema se
            basa en la identificación de "Fugas No Verbales" en grupos de tres.
          </p>
        </div>

        <div className="mb-16 max-w-2xl mx-auto" data-id="element-113">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50" data-id="element-114">
            <img src="https://cdn.magicpatterns.com/uploads/cgnZwGWXPacswF4Pa375VB/Gemini_Generated_Image_r6jcjr6jcjr6jcjr.jpg" alt="Detecta la mentira en segundos - Antes y Después" className="w-full object-cover" data-id="element-115" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent pointer-events-none" data-id="element-116"></div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-117">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500/5 rounded-full blur-3xl" data-id="element-118"></div>

          <div className="relative z-10" data-id="element-119">
            <h3 className="text-2xl font-bold text-brand-400 mb-6 flex items-center" data-id="element-120">
              <ZapIcon className="h-6 w-6 mr-3" data-id="element-121" />
              El Retraso Cognitivo
            </h3>
            <p className="text-lg text-slate-300 leading-relaxed mb-8" data-id="element-122">
              Aprenderás a detectar el retraso cognitivo —ese milisegundo donde
              el cerebro límbico revela la verdad antes de que la boca pueda
              fabricar la mentira.{' '}
              <span className="text-white font-semibold" data-id="element-123">
                No es intuición; es observación táctica aplicada al
                comportamiento humano.
              </span>
            </p>

            <div className="grid md:grid-cols-3 gap-6 mt-10" data-id="element-124">
              <div className="bg-slate-900/80 p-6 rounded-xl border border-slate-700/50" data-id="element-125">
                <div className="text-brand-500 font-black text-4xl mb-4 opacity-50" data-id="element-126">
                  01
                </div>
                <h4 className="text-white font-bold mb-2" data-id="element-127">
                  Identifica la Línea Base
                </h4>
                <p className="text-sm text-slate-400" data-id="element-128">
                  Aprende a leer cómo se comporta la persona cuando dice la
                  verdad.
                </p>
              </div>

              <div className="bg-slate-900/80 p-6 rounded-xl border border-slate-700/50" data-id="element-129">
                <div className="text-brand-500 font-black text-4xl mb-4 opacity-50" data-id="element-130">
                  02
                </div>
                <h4 className="text-white font-bold mb-2" data-id="element-131">
                  Lanza la Pregunta Sonda
                </h4>
                <p className="text-sm text-slate-400" data-id="element-132">
                  Provoca la fuga de información de manera sutil.
                </p>
              </div>

              <div className="bg-slate-900/80 p-6 rounded-xl border border-slate-700/50" data-id="element-133">
                <div className="text-brand-500 font-black text-4xl mb-4 opacity-50" data-id="element-134">
                  03
                </div>
                <h4 className="text-white font-bold mb-2" data-id="element-135">
                  Detecta el Clúster
                </h4>
                <p className="text-sm text-slate-400" data-id="element-136">
                  Confirma la mentira identificando 3 señales simultáneas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}